import React from 'react'
import { when } from 'mobx'
import { observer, inject } from 'mobx-react'
import * as ReactGA from 'react-ga'
import storage from 'core/storage'
import { isCorrupt, byId } from 'core/utils'
import optionsContext from 'core/OptionsContext'
import { IdleTimerContainer } from 'components/misc'
import ChatWidget from './ChatWidget'

@inject('store', 'actions')
@observer
class ChatWindowUser extends React.Component {
  state = {}

  static contextType = optionsContext


  componentDidMount() {
    const { store, actions } = this.props
    ReactGA.initialize('UA-110819011-1')
    ReactGA.pageview(window.location.pathname + window.location.search)

    // Initialize websocket connection
    when(() => (store?.token), async() => {
      const [options, setOptionsContext] = this.context
      actions.chat.initWebSocket(true)

      const initialRequests = [
        actions.widget.fetchConversationsForUser(CONFIG.userUid, CONFIG.siteDomain),
      ]
      if (options.features.fetchExtraFeatureSwitches) {
        initialRequests.push(actions.widget.fetchWidgetConfig().then(([fs]) => setOptionsContext({ ...options, features: { ...options.features, ...fs } })))
      }
      await Promise.all(initialRequests)

      actions.user.setAccountType()
      this.setConversation()
      this.setState({ ready: true })
    })
  }

  setConversation() {
    const { actions, store } = this.props
    const conversations = store.visibleConversations

    if (!store.conversationUid && conversations.length) {
      let conversationUid = storage.get(`conversation-${CONFIG.userUid}`, null)
      const conversation = conversations.find(byId(conversationUid))
      if (!conversation || isCorrupt(conversation)) {
        conversationUid = conversations[0].conversationUid
      }

      actions.chat.setUserConversation(conversationUid)
    }
  }

  render() {
    return (
      <>
        { this.state.ready ? <ChatWidget options={this.props.options}/> : null }
        <IdleTimerContainer type="user"/>
      </>
    )
  }
}

export default ChatWindowUser
